
<div class="site-panel">
    <v-row class="no-frame">
        <v-col class="main-first-col modal-tab no-border">
            <v-row class="no-frame">
                <c-site-contact-column
                    title      = "Ansprechpartner Kunde"
                    :contacts  = "site.contacts.customer"
                    :company   = "customer"
                    :company-role = "Company.roles.customer"
                    @dissolve  = "onDissolve"
                    @assigned  = "onAssigned"
                    :key       = "refresh.customer"
                />
            </v-row>
        </v-col>
        <v-col class="main-middlle-col modal-tab no-border">
            <v-row class="no-frame">
                <c-site-contact-column
                    title      = "Ansprechpartner vor Ort"
                    :contacts  = "site.contacts.onSite"
                    :company   = "customer"
                    :company-role = "Company.roles.facilitymanagement"
                    :onsite    = "true"
                    @dissolve  = "onDissolve"
                    @assigned  = "onAssigned"
                    :key       = "refresh.onSite"
                />
            </v-row>
        </v-col>
        <v-col class="main-middlle-col modal-tab no-border">
            <v-row class="no-frame">
                <c-flip-card
                    class="w-100"
                    :top="8"
                    :right="12"
                    color="white--text"
                    front-text="Wartungsnehmer"
                    back-text="Notrufnehmer"
                >
                    <template v-slot:front>
                        <c-site-contact-column
                            class="white"
                            title      = "Kontakte Wartungsnehmer"
                            :contacts  = "site.contacts.maintenance"
                            :company   = "mntCompany"
                            :company-role = "Company.roles.maintenance"
                            @dissolve  = "onDissolve"
                            @assigned  = "onAssigned"
                            :key       = "refresh.maintenance"
                        />
                    </template>
                    <template v-slot:back>
                        <c-site-contact-column
                            class="white"
                            title      = "Kontakte Notrufnehmer"
                            :contacts  = "site.contacts.emc"
                            :company   = "emcCompany"
                            :company-role = "Company.roles.escalation"
                            :zus       = "false"
                            @dissolve  = "onDissolve"
                            @assigned  = "onAssigned"
                            :key       = "refresh.emc"
                        />
                    </template>
                </c-flip-card>
            </v-row>
        </v-col>
        <v-col class="main-last-col modal-tab no-border" style="padding-right: 1px">
            <v-row class="no-frame">
                <c-site-contact-column
                    title      = "Kontakte ZÜS"
                    :contacts  = "site.contacts.zus"
                    :company   = "zusCompany"
                    :company-role = "Company.roles.inspection"
                    :zus       = "true"
                    @dissolve  = "onDissolve"
                    @assigned  = "onAssigned"
                    :key       = "refresh.zus"
                />
            </v-row>
        </v-col>
    </v-row>
    <v-divider />
</div>
